export default class {

	constructor(obj) {
		this.id = obj.id
		this.creditId = obj.creditid
		this.credit = obj.credit
		this.creditTypeId = obj.credittypeid
		this.selectionId = obj.selectionid
		this.date = obj.date
	}
}



// WEBPACK FOOTER //
// ./src/home/dto/DtoUserCreditHistory.js